import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import {
  Box,
  Grid,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { styled } from "@mui/system";
import month_1 from '../../../assets/months/month_01.jpg';
import month_2 from '../../../assets/months/month_02.jpg';
import month_3 from '../../../assets/months/month_03.jpg';
import month_4 from '../../../assets/months/month_04.jpg';
import month_5 from '../../../assets/months/month_05.jpg';
import month_6 from '../../../assets/months/month_06.jpg';
import month_7 from '../../../assets/months/month_07.jpg';
import month_8 from '../../../assets/months/month_08.jpg';
import month_9 from '../../../assets/months/month_09.jpg';
import month_10 from '../../../assets/months/month_10.jpg';
import month_11 from '../../../assets/months/month_11.jpg';
import month_12 from '../../../assets/months/month_12.jpg';

export default function CustomCalendar() {
  const [allMonthDate, setAllMonthDate] = useState(dayjs());
  const [mainMonthDate, setMainMonthDate] = useState(dayjs());
  const [selectedMonth, setSelectedMonth] = useState();

  const allMonths = [month_1, month_2, month_3, month_4, month_5, month_6, month_7, month_8, month_9, month_10, month_11, month_12]

  useEffect(() => {
    const current_date = new Date();
    setSelectedMonth(current_date.getMonth());
  }, []);
  const AllMonthHeader = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
    
    & img {
      height: 80px !important;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      min-width: 100%;
    }
  `;
  const MainMonthHeader = styled("div")`
    display: flex;

    & img {
      min-width: 320px;
      width:100%;
    }
  `;
  const handleTodayClick = (newDate) => {
    const today = dayjs();
    setMainMonthDate(newDate);
    setAllMonthDate(null);
    if (newDate.isSame(today, 'day')) {
      setSelectedMonth(today.$M);
    }
  }

  const AllMonthCalendar = styled(StaticDatePicker)`
  .MuiPickersDay-root.Mui-selected {
    background-color: transparent;
    color: inherit;
  }
  .muiltr-cwhad8-MuiDateCalendar-root{
    max-height: 128px;
    max-width: 180px !important;
  }
  .muiltr-xjch61-MuiButtonBase-root-MuiPickersDay-root{
    height: 14px !important;
    margin: 0 !important;
  }
  .muiltr-nk89i7-MuiPickersCalendarHeader-root{
    display : none
  }
  .muiltr-flbe84-MuiDayCalendar-weekContainer {
    margin: 0 !important
  }
  .muiltr-1166rke-MuiButtonBase-root-MuiPickersDay-root {
    height: 14px !important;
    margin: 0 !important;
  }
  .muiltr-1e1pkmj-MuiPickersDay-root {
    height: 0px !important;
    margin: 0 !important;
  }
  .muiltr-1crkva0-MuiTypography-root-MuiDayCalendar-weekDayLabel{
    margin: 0 !important;
  }
  .muiltr-hlj6pa-MuiDialogActions-root{
    display: none;
  }
  .muiltr-i5q14k-MuiDayCalendar-header{
    justify-content: flex-start;
  }
  .muiltr-flbe84-MuiDayCalendar-weekContainer{
    justify-content: flex-start;
  }
  .muiltr-1eurbeq-MuiPickersToolbar-root-MuiDatePickerToolbar-root {
    display:none;
  }
  .muiltr-MuiDateCalendar-viewTransitionContainer{
    width : 180px !important;
  }
  .css-12975om-MuiPickersDay-root {
    width : 180px !important;
  }
  .muiltr-16b5y55-MuiPickersLayout-contentWrapper{
    grid-column: 1 !important;
    grid-row: 1 !important;
  }
  `;
  const MainMonthCalendar = styled(StaticDatePicker)`
  .muiltr-9reuh9-MuiPickersArrowSwitcher-root {
    display: none !important;
  }
  `;

  const generateGridItems = (startMonth, endMonth) => {
    const gridItems = [];

    for (let month = startMonth; month <= endMonth; month++) {
      let curr_dt = new Date();
      let formattedDate = mainMonthDate.$y + "-" + month + "-" + curr_dt.getDate();
      const allMonthImage = allMonths[month - 1]

      const gridItem = (
        <Grid item xs={4} spacing={2} key={formattedDate} sx={{ minWidth: "180px" }}>
          <Box display="flex" alignItems="row" justifyContent="space-between">
            <Box sx={{ border: "1px solid black", minWidth: "100%" }}>
              <AllMonthHeader>
                {allMonthImage && (<img src={allMonthImage} alt="Calendar Header" />)}
              </AllMonthHeader>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <AllMonthCalendar
                  defaultValue={dayjs(formattedDate)}
                  sx={{
                    height: "125px",
                    minWidth: "180px",
                    gridAutoColumns: "auto",
                  }}
                  onChange={(e) => {
                    setAllMonthDate(e);
                    setSelectedMonth(e.$M);
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Box>
        </Grid>
      );
      gridItems.push(gridItem);
    }
    return gridItems;
  };

  return (
    <>
      <Grid container spacing={2} columnSpacing={5} className="items-center">
        <Grid item xs={4}>
          <MainMonthHeader>
            {
              <img src={allMonths[selectedMonth]} alt="Calendar Header" />
            }
          </MainMonthHeader>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MainMonthCalendar
              value={allMonthDate ? allMonthDate : mainMonthDate}
              slotProps={{
                actionBar: {
                  actions: ["today"],
                },
              }}
              onChange={handleTodayClick}

            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={8}>
          <Grid marginTop={0} container spacing={2}>
            {generateGridItems(1, 3)}
          </Grid>
          <Grid marginTop={0} container spacing={2}>
            {generateGridItems(4, 6)}
          </Grid>
          <Grid marginTop={0} container spacing={2}>
            {generateGridItems(7, 9)}
          </Grid>
          <Grid marginTop={0} container spacing={2}>
            {generateGridItems(10, 12)}
          </Grid>

        </Grid>
      </Grid>
    </>
  );
}
